import { useIsVendor } from "@/hooks/useIsVendor";

/** Feature key for Vendor Management in features JSON (mainSidebarItems) */
export const VENDOR_MANAGEMENT_FEATURE_KEY = "vendorManagement";

const LABELS = {
  /** Shown to TJ / non-vendor users */
  default: { title: "Vendor Management" },
  /** Shown to vendor users */
  vendor: { title: "Vendor Profile" },
} as const;

/**
 * Returns the display label for the Vendor Management tile based on whether
 * the logged-in user is a vendor. Use in dashboard, sidebar, and breadcrumbs
 * so the label stays consistent.
 */
export function useVendorManagementLabel(): { title: string } {
  const isVendor = useIsVendor();
  return isVendor ? LABELS.vendor : LABELS.default;
}
